export default "__VITE_ASSET__BFSvBmT2__"